export default __webpack_public_path__ + "d9070f23c2dc854d1b06a71943e3d850.png";